import { render, staticRenderFns } from "./BotaoVerLoja.vue?vue&type=template&id=11393d71&scoped=true&lang=pug"
import script from "./BotaoVerLoja.vue?vue&type=script&lang=js"
export * from "./BotaoVerLoja.vue?vue&type=script&lang=js"
import style0 from "./BotaoVerLoja.vue?vue&type=style&index=0&id=11393d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11393d71",
  null
  
)

export default component.exports